import {
    optionTitle_messageHeight,
    optionTitle_textSizeSpacing,
} from './DisplayDensityOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
const titleString = isFeatureEnabled('mon-densities')
    ? optionTitle_textSizeSpacing
    : optionTitle_messageHeight;
const DisplayDensityOption: LazyOption = createLazyOption(
    {
        key: 'Density',
        titleStringKey: titleString,
        searchTermsStringKey: titleString,
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default DisplayDensityOption;
